import * as _ from "lodash";

import { BaseDto } from "./base.dto";
import { FileDto } from "./file.dto";
import { PagingDto } from "./paging.dto";
import { TranslationDto } from "./translation.dto";

class ImageNotificationDto {
  en?: {
    url?: string;
    id?: string;
  };
  kh?: {
    url?: string;
    id?: string;
  };
}

// mapping to form
export class NotificationMappingDto extends BaseDto {
  id?: string;
  imageId?: TranslationDto;
  title?: TranslationDto;
  description?: TranslationDto;
  target?: number;
  contentType?: number;
  contentLinkedType?: number;
  contentLinkedId?: string;
  manualContent?: TranslationDto;
  targetUrl?: TranslationDto;
  schedule?: string;
  enabled?: boolean;
  status?: boolean;
  scheduleType?: number;
  targetFileId?: string;
  targetFileName?: string;
  isSent?: boolean;
  static create({
    id,
    imageId,
    title,
    description,
    target,
    contentType,
    contentLinkedType,
    contentLinkedId,
    manualContent,
    targetUrl,
    schedule,
    enabled,
    scheduleType,
    status,
    targetFileId,
    targetFileName,
    isSent
  }: NotificationMappingDto) {
    return _.assign<NotificationMappingDto>({
      id: id || null,
      imageId: imageId || TranslationDto.create(),
      title: title || TranslationDto.create(),
      description: description || TranslationDto.create(),
      target: target || null,
      contentType: contentType || null,
      contentLinkedType: contentLinkedType || null,
      contentLinkedId: contentLinkedId || null,
      manualContent: manualContent || TranslationDto.create(),
      targetUrl: targetUrl || TranslationDto.create(),
      scheduleType: scheduleType ?? null,
      schedule: schedule || null,
      enabled: enabled || true,
      status: status || true,
      targetFileId: targetFileId || null,
      targetFileName: targetFileName || null,
      isSent: isSent || false,
    });
  }
}

// event response
export class NotificationDto extends BaseDto {
  imageId?: ImageNotificationDto;
  title?: TranslationDto;
  description?: TranslationDto;
  target?: number;
  contentType?: number;
  contentLinkedType?: number;
  contentLinkedId?: string;
  manualContent?: TranslationDto;
  targetUrl?: TranslationDto;
  scheduleType?: number;
  schedule?: string;
  enabled?: boolean;
  status?: boolean;
  sent?: number;
  sentFailed?: number;
  targetFileId?: string;
  targetFile?: FileDto;
}

export class FindNotificationDto extends PagingDto {
  search?: string;
}

export class CreateNotificationDto extends NotificationMappingDto {
}

export class UpdateNotificationDto extends CreateNotificationDto {
  id?: string;
}
